// Htg companies to merge
const MERGE_MAP = {
  HWT: 'Tyre',
  EKT: 'Tyre',
}

// Group a point breakdown by merge map
// points are summed up on merge
// if not on map, will remain as is
export const groupByProduct = (pointBreakdown) => {
  const merged = Object.values(
    pointBreakdown.reduce((acc, e) => {
      const key = MERGE_MAP[e.htgCompany] || e.htgCompany

      if (!acc[key]) {
        acc[key] = { ...e, htgCompany: key, points: 0 }
      }

      acc[key].points += e.points
      return acc
    }, {}),
  )

  return merged
}
